<template>
  <v-sheet class="" height="100%">

    <template v-if="urlArgs.id">

      <div class="pa-4">
        <div class="headline text--primary">
          {{ urlArgs.name }}
        </div>
      </div>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
          icon
          small
          v-on="on"
          @click.stop="$router.push('/inventory/inventory-definition/view/' + urlArgs.id)"
          >
            <v-icon small>mdi-application-import</v-icon>
          </v-btn>
        </template>
        <span>View this item in the main view</span>
      </v-tooltip>

      <div class="pa-2">

        <v-tabs
        class="mt-2"
        fixed-tabs
        color="color1"
        v-model="tab"
        >
          <v-tab>
            Inventory
          </v-tab>
          <v-tab>
            History
          </v-tab>
        </v-tabs>
        <div class="">

          <inventory
          v-if="tab === 0"
          :id="urlArgs.id">
          </inventory>

          <history
          v-if="tab === 1"
          :id="urlArgs.id">
          </history>

        </div>

      </div>

    </template>

    <div v-else>
      <v-row class="pa-2 justify-center">
        Select a row
      </v-row>
      <v-img src="https://cdn.pixabay.com/photo/2017/04/08/22/26/meditation-2214532_1280.jpg">
      </v-img>
    </div>

  </v-sheet>
</template>

<script>
import Inventory from './inventory/Main'
import History from './history/Main'

export default {
  components: {
    Inventory,
    History
  },
  props: ['url', 'urlArgs'],
  data () {
    return {
      tab: 0
    }
  },
  created () {
  }
}
</script>